import { FC, useEffect } from 'react';
import { VStack, Button } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { CreateCardDeckVariantData } from '@olagg/db-types';
import OlaggForm from '../../../components/Forms/OlaggForm';
import OlaggFormInput from '../../../components/Forms/OlaggFormInput';
import { formVariantSchema } from '@olagg/validation-schemas/cardDecks.schemas';
import { yupResolver } from '@hookform/resolvers/yup';

interface VariantFormProps {
  onSubmit: (dataForm: CreateCardDeckVariantData) => void;
  variant?: CreateCardDeckVariantData;
}

const VariantForm: FC<VariantFormProps> = ({ onSubmit, variant }) => {
  const useFormMethods = useForm<CreateCardDeckVariantData>({
    resolver: yupResolver(formVariantSchema),
    mode: 'onChange',
  });

  useEffect(() => {
    if (variant) {
      useFormMethods.reset(variant);
    }
  }, [variant]);

  return (
    <OlaggForm
      useFormMethods={useFormMethods}
      onSubmit={onSubmit}
      style={{
        width: '100%'
      }}
    >
      <VStack spacing={4} maxW='600px' margin='0 auto'>
        <OlaggFormInput
          label='Nombre'
          controlName='name'
          required={true}
        />

        <OlaggFormInput
          label='Nombre (inglés)'
          controlName='nameEn'
        />

        <OlaggFormInput
          label='Nombre (portugués)'
          controlName='namePt'
        />

        <OlaggFormInput
          label='Descripcion'
          controlName='description'
          required={false}
        />

        <OlaggFormInput
          label='Descripcion (inglés)'
          controlName='descriptionEn'
        />

        <OlaggFormInput
          label='Descripcion (portugués)'
          controlName='descriptionPt'
        />

        <OlaggFormInput
          label='Probabilidad'
          description='La probabilidad puede ser entre 0 y 100'
          inputType='number'
          controlName='probability'
          required={true}
        />

        <OlaggFormInput
          label='Imagen'
          description='URL de la imagen'
          controlName='imageUrl'
          required={true}
        />

        <Button
          variant={'filledGradient'}
          type="submit"
          w={'full'}
          style={{
            marginTop: '30px'
          }}
        >
          Guardar
        </Button>
      </VStack>
    </OlaggForm>
  );
};

export default VariantForm; 
